/* eslint-disable no-alert */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import UnitSelect from "components/Textfields/UnitSelect";
import ServiceSelect from "components/Textfields/ServiceSelect";
import TransactionTypeSelect from "components/Textfields/SelectTransType";
import SelectLevel from "components/Textfields/SelectLevel";
import { useFormik } from "formik";
import PersonalInfoValidation from "../../../schema/personal-info";
import DesignationSelect from "../../../components/Textfields/SelectDesignation";

export default function PersonalInfo({ details, updateDetails }) {
  const [units, setUnits] = useState([]);
  const [services, setServices] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [specificAge, setSpecificAge] = useState([]);
  const [transTypes, setTransTypes] = useState([]);
  const [designation, setDesignation] = useState([]);

  const formik = useFormik({
    initialValues: {
      ...details.submitter,
      ...details.serviceFeedback,
    },
    validationSchema: PersonalInfoValidation,
  });

  useEffect(() => {
    updateDetails(formik.values);
  }, [formik.values]);

  // console.log(formik.values);

  const label =
    formik?.values?.designationId === 2
      ? "School Visited"
      : "Office/Unit/Section Visited";

  return (
    <Box
      sx={{
        my: 5,
        width: "100%",
      }}
    >
      {units.length !== 0 &&
        services.length !== 0 &&
        specificAge.length !== 0 &&
        transTypes.length !== 0 && (
          <Typography sx={{ color: "red", fontWeight: "bold" }}>
            Unable to get data
          </Typography>
        )}

      <Box
        variant="form"
        component="form"
        onSubmit={formik.handleSubmit}
        autoComplete="off"
      >
        <TextField
          id="name"
          label="Full Name (Optional)"
          variant="outlined"
          size="small"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
          fullWidth
          sx={{
            mb: 2,
            "& .MuiInputBase-root": {
              fontSize: { xs: "0.875rem", sm: "1rem" }, // Adjust input size
              height: { xs: 40, sm: 48 }, // Adjust height
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" }, // Adjust label size
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem" }, // Adjust helper text
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
          }}
        />
        <Grid container spacing={1} sx={{ mb: 2 }}>
          <Grid
            item
            xs={12}
            sm={8}
            // xs={8.5}
          >
            <TextField
              id="email"
              label="Mobile Number or Email Address (Optional)"
              variant="outlined"
              size="small"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={(e) => {
                formik.handleBlur(e);
              }}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              fullWidth
              sx={{
                // mb: 2,

                "& .MuiInputBase-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem", xl: "1rem" },
                  height: { xs: 40, sm: 48 },
                },
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" },
                  "@media (min-height: 1080px)": {
                    fontSize: "1rem",
                  },
                },
                "& .MuiFormHelperText-root": {
                  fontSize: { xs: "0.7rem", sm: "0.8rem" },
                  "@media (min-height: 1080px)": {
                    fontSize: "1rem",
                  },
                },
              }}
            />
          </Grid>
          {/* <Grid item xs={0.5} /> */}

          <Grid
            item
            xs={12}
            sm={4}
            // xs={3}
          >
            <TextField
              label="Age"
              size="small"
              name="specAge"
              value={formik.values.specAge}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.specAge && Boolean(formik.errors.specAge)}
              helperText={formik.touched.specAge && formik.errors.specAge}
              sx={{
                width: { xl: "100%" },
                "& .MuiInputBase-root": {
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                  height: { xs: 40, sm: 48 },
                },
                "& .MuiInputLabel-root": {
                  fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" },
                  "@media (min-height: 1080px)": {
                    fontSize: "1rem",
                  },
                },
                "& .MuiFormHelperText-root": {
                  fontSize: { xs: "0.7rem", sm: "0.8rem" },
                  "@media (min-height: 1080px)": {
                    fontSize: "1rem",
                  },
                },
              }}
            />
          </Grid>
        </Grid>

        <FormControl component="fieldset" sx={{ mb: 2, mt: 2 }}>
          <FormLabel component="legend">Sex{formik.touched.sex}</FormLabel>
          <RadioGroup
            aria-label="sex"
            name="sex"
            value={formik.values.sex}
            disabled={!formik.values.clientTypeId}
            onChange={(evt) => formik.setFieldValue("sex", evt.target.value)}
            onBlur={(e) => {
              formik.handleBlur(e);
            }}
            error={formik.touched.sex && Boolean(formik.errors.sex)}
            helperText={formik.touched.sex && formik.errors.sex}
            sx={{ ml: 2 }}
            row
          >
            <FormControlLabel value="Male" control={<Radio />} label="Male" />
            <FormControlLabel
              value="Female"
              control={<Radio />}
              label="Female"
            />
            <FormControlLabel
              value="Prefer not to say"
              control={<Radio />}
              label="Prefer not to say"
            />
          </RadioGroup>
        </FormControl>

        <TransactionTypeSelect
          label="Transaction Type"
          name="clientTypeId"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              fontSize: { xs: "0.875rem", sm: "1rem", xl: "2rem" },
              height: { xs: 40, sm: 48 },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "2rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem", xl: "2rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
          }}
          value={formik.values.clientTypeId}
          onChange={(fieldName, selectedValue) => {
            formik.handleChange({
              target: { name: "clientTypeId", value: selectedValue },
            });
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
          }}
          error={
            formik.touched.clientTypeId && Boolean(formik.errors.clientTypeId)
          }
          helperText={formik.touched.clientTypeId && formik.errors.clientTypeId}
          hasData={setTransTypes}
          disabled={!formik.values.specAge}
        />

        <DesignationSelect
          label="Select Location"
          name="designationId"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              fontSize: { xs: "0.875rem", sm: "1rem", xl: "2rem" },
              height: { xs: 40, sm: 48 },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "2rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem", xl: "2rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
          }}
          value={formik?.values?.designationId}
          onChange={(fieldName, selectedValue) => {
            formik.handleChange({
              target: { name: "designationId", value: selectedValue },
            });
            if (selectedValue === 1) {
              formik.handleChange({
                target: { name: "levelId", value: null },
              });
            }
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
          }}
          error={
            formik?.touched?.designationId &&
            Boolean(formik?.errors?.designationId)
          }
          helperText={
            formik.touched?.designationId && formik?.errors?.designationId
          }
          hasData={setDesignation}
          disabled={!formik?.values?.specAge}
        />

        {formik?.values?.designationId === 2 && (
          <SelectLevel
            label="Select Level"
            name="levelId"
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: { xs: "0.875rem", sm: "1rem", xl: "2rem" },
                height: { xs: 40, sm: 48 },
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "2rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              },
              "& .MuiFormHelperText-root": {
                fontSize: { xs: "0.7rem", sm: "0.8rem", xl: "2rem" },
                "@media (min-height: 1080px)": {
                  fontSize: "1rem",
                },
              },
            }}
            value={formik?.values?.levelId}
            onChange={(fieldName, selectedValue) => {
              formik.handleChange({
                target: { name: "levelId", value: selectedValue },
              });
            }}
            onBlur={(e) => {
              formik.handleBlur(e);
            }}
            error={formik?.touched?.levelId && Boolean(formik?.errors?.levelId)}
            helperText={formik.touched?.levelId && formik?.errors?.levelId}
            hasData={setDesignation}
            disabled={formik?.values?.designationId !== 2}
          />
        )}

        <UnitSelect
          label={label}
          name="officeId"
          sx={{
            mb: 2,
            width: "100%",
            "& .MuiInputBase-root": {
              fontSize: { xs: "0.875rem", sm: "1rem", xl: "1rem" },
              height: { xs: 40, sm: 48 },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
          }}
          value={formik.values.officeId}
          onChange={(fieldName, selectedValue) => {
            formik.handleChange({
              target: { name: "officeId", value: selectedValue },
            });
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
          }}
          error={formik.touched.officeId && Boolean(formik.errors.officeId)}
          helperText={formik.touched.officeId && formik.errors.officeId}
          hasData={setUnits}
          options={filteredUnits}
          disabled={!formik.values.clientTypeId}
          levelId={formik.values.levelId}
          designationId={formik.values.designationId}
        />

        <ServiceSelect
          label="Service/s Received (Serbisyong Natanggap)"
          name="serviceId"
          sx={{
            mb: 2,
            width: "100%",
            "& .MuiInputBase-root": {
              fontSize: { xs: "0.875rem", sm: "1rem", xl: "1rem" },
              height: { xs: 40, sm: 48 },
            },
            "& .MuiInputLabel-root": {
              fontSize: { xs: "0.75rem", sm: "0.875rem", xl: "1rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
            "& .MuiFormHelperText-root": {
              fontSize: { xs: "0.7rem", sm: "0.8rem" },
              "@media (min-height: 1080px)": {
                fontSize: "1rem",
              },
            },
          }}
          value={formik.values.serviceId}
          onChange={(fieldName, selectedValue) => {
            formik.handleChange({
              target: { name: "serviceId", value: selectedValue },
            });
          }}
          onBlur={(e) => {
            formik.handleBlur(e);
          }}
          error={formik.touched.serviceId && Boolean(formik.errors.serviceId)}
          helperText={formik.touched.serviceId && formik.errors.serviceId}
          officeId={formik.values.officeId}
          serviceKindId={formik.values.serviceKindId}
          hasData={setServices}
          disabled={!formik.values.officeId}
        />

        {formik.values.serviceId === 4 && (
          <TextField
            id="otherService"
            label="If Others, Please Specify"
            variant="outlined"
            size="small"
            value={formik.values.otherService}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.otherService && Boolean(formik.errors.otherService)
            }
            helperText={
              formik.touched.otherService && formik.errors.otherService
            }
            fullWidth
            multiline
            rows={4}
            sx={{
              // mt: 2,
              mb: 2,
              width: "100%",
              "& .MuiInputBase-root": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
                // height: { xs: 40, sm: 48 },
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              },
              "& .MuiFormHelperText-root": {
                fontSize: { xs: "0.7rem", sm: "0.8rem" },
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
}
